function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30807",
  "data-name": "Group 30807"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5223",
  "data-name": "Rectangle 5223",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59683",
  "data-name": "Path 59683",
  d: "M18,12h0a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H19A1,1,0,0,0,18,12Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59684",
  "data-name": "Path 59684",
  d: "M16.59,16.82a.966.966,0,0,0,.2,1.37c.53.39,1.09.81,1.62,1.21a.978.978,0,0,0,1.38-.2c0-.01.01-.01.01-.02a.978.978,0,0,0-.2-1.38c-.53-.4-1.09-.82-1.61-1.21a.993.993,0,0,0-1.39.21A.035.035,0,0,1,16.59,16.82Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59685",
  "data-name": "Path 59685",
  d: "M19.81,4.81c0-.01-.01-.01-.01-.02a.98.98,0,0,0-1.38-.2c-.53.4-1.1.82-1.62,1.22a.979.979,0,0,0-.19,1.38c0,.01.01.01.01.02a.979.979,0,0,0,1.38.2c.53-.39,1.09-.82,1.62-1.22A.994.994,0,0,0,19.81,4.81Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59686",
  "data-name": "Path 59686",
  d: "M8,9H4a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2H5v3a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V15H8l5,3V6Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59687",
  "data-name": "Path 59687",
  d: "M15.5,12A4.48,4.48,0,0,0,14,8.65v6.69A4.442,4.442,0,0,0,15.5,12Z"
});

function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "campaign_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.15412cd9.svg";
export { ForwardRef as ReactComponent };